// AwaitingReport.tsx

import * as React from 'react';
import ReporterOverview from './Components/ReporterOverview';
import CustomMenu from '../../components/CustomMenu/CustomMenu';

/**
 * 報告待ちページコンポーネント
 * - カスタムメニュー内に報告待ち一覧を表示する
 */
export default function AwaitingReport() {
  return (
    <CustomMenu>
      <ReporterOverview />
    </CustomMenu>
  );
}
